const ethers = require("ethers");
const { BondMath } = require("../math");

async function createMarket(contracts, marketType, params) {
  const auctioneer = contracts.getContractByName(params.contractName);

  let hashedParams;
  switch (marketType) {
    case "FPA":
      hashedParams = _prepareFPAMarketParams(params);
      break;
    case "OFDA":
      hashedParams = _prepareOFDAMarketParams(params);
      break;
    case "SDA":
      hashedParams = _prepareSDAMarketParams(params);
      break;
    case "OSDA":
      hashedParams = _prepareOSDAMarketParams(params);
      break;
  }

  let optionalArgs = {};
  if (params.payoutToken == ethers.constants.AddressZero) {
    optionalArgs.value = params.capacity;
  }

  return await auctioneer.createMarket(hashedParams, optionalArgs);
}

async function bondAuctioneerIsNewMarketsAllowed(contracts, contractName) {
  const auctioneer = contracts.getContractByName(contractName);
  return await auctioneer.allowNewMarkets();
}

async function bondAuctioneerGetMinDepositInterval(contracts, contractName) {
  const auctioneer = contracts.getContractByName(contractName);
  return await auctioneer.minDepositInterval();
}

async function bondAuctioneerGetMinMarketDuration(contracts, contractName) {
  const auctioneer = contracts.getContractByName(contractName);
  return await auctioneer.minMarketDuration();
}

async function bondAuctioneerMarketPrice(contracts, contractName, id) {
  const auctioneer = contracts.getContractByName(contractName);
  return await auctioneer.marketPrice(id);
}

async function bondAuctioneerGetTeller(contracts, contractName) {
  const auctioneer = contracts.getContractByName(contractName);
  return await auctioneer.getTeller();
}

function _prepareFPAMarketParams({
  payoutDecimals,
  payoutPrice,
  quoteDecimals,
  quotePrice,
  discount,
  payoutToken,
  quoteToken,
  capacity,
  depositInterval,
  vesting,
  start,
  duration,
}) {
  const { formattedPrice, scaleAdjustment } = BondMath.calculateFPAMarketParameters(
    payoutDecimals,
    payoutPrice,
    quoteDecimals,
    quotePrice,
    discount
  );

  const hashedParams = ethers.utils.defaultAbiCoder.encode(
    ["address", "address", "uint256", "uint256", "uint48", "uint48", "uint48", "uint48", "int8"],
    [payoutToken, quoteToken, capacity, formattedPrice, depositInterval, vesting, start, duration, scaleAdjustment]
  );

  return hashedParams;
}

function _prepareOFDAMarketParams({
  payoutToken,
  quoteToken,
  oracle,
  fixedDiscount,
  maxDiscountFromCurrent,
  capacity,
  depositInterval,
  vesting,
  start,
  duration,
}) {
  // TODO: check this
  const hashedParams = ethers.utils.defaultAbiCoder.encode(
    ["address", "address", "address", "uint48", "uint48", "uint256", "uint48", "uint48", "uint48", "uint48"],
    [
      payoutToken,
      quoteToken,
      oracle,
      fixedDiscount * 1_000, // 3 decimals of precision, e.g. 10_000 = 10%.
      maxDiscountFromCurrent * 1_000, // 3 decimals of precision, e.g. 10_000 = 10%.
      capacity,
      depositInterval,
      vesting,
      start,
      duration,
    ]
  );

  return hashedParams;
}

function _prepareSDAMarketParams({
  payoutDecimals,
  quoteDecimals,
  quotePrice,
  payoutToken,
  quoteToken,
  capacity,
  initialPrice,
  minimumPrice,
  debtBuffer,
  vesting,
  start,
  duration,
  depositInterval,
}) {
  const { formattedInitialPrice, formattedMinimumPrice, scaleAdjustment } = BondMath.calculateSDAMarketParameters(
    payoutDecimals,
    initialPrice,
    minimumPrice,
    quoteDecimals,
    quotePrice
  );

  const hashedParams = ethers.utils.defaultAbiCoder.encode(
    ["address", "address", "uint256", "uint256", "uint256", "uint32", "uint48", "uint48", "uint32", "uint32", "int8"],
    [
      payoutToken,
      quoteToken,
      capacity,
      formattedInitialPrice,
      formattedMinimumPrice,
      debtBuffer * 1_000, // 3 decimals of precision, e.g. 10_000 = 10%.
      vesting,
      start,
      duration,
      depositInterval,
      scaleAdjustment,
    ]
  );

  return hashedParams;
}

function _prepareOSDAMarketParams({
  payoutToken,
  quoteToken,
  oracle,
  baseDiscount,
  maxDiscountFromCurrent,
  targetIntervalDiscount,
  capacity,
  depositInterval,
  vesting,
  start,
  duration,
}) {
  // TODO: check this
  const hashedParams = ethers.utils.defaultAbiCoder.encode(
    ["address", "address", "address", "uint48", "uint48", "uint48", "uint256", "uint48", "uint48", "uint48", "uint48"],
    [
      payoutToken,
      quoteToken,
      oracle,
      baseDiscount * 1_000, // 3 decimals of precision, e.g. 10_000 = 10%.
      maxDiscountFromCurrent * 1_000, // 3 decimals of precision, e.g. 10_000 = 10%.
      targetIntervalDiscount,
      capacity,
      depositInterval,
      vesting,
      start,
      duration,
    ]
  );

  return hashedParams;
}

module.exports = {
  createMarket,
  bondAuctioneerIsNewMarketsAllowed,
  bondAuctioneerGetMinDepositInterval,
  bondAuctioneerGetMinMarketDuration,
  bondAuctioneerMarketPrice,
  bondAuctioneerGetTeller,
};
